var Handlebars = require("../../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"text-area-shape\">\n    <div class=\"ta-shape-header\">\n        <div class=\"ta-shape-caption-wr\">\n            Enter text:\n        </div>\n        <div class=\"ta-shape-btn-panel-wr\">\n            <span class=\"ta-btn-wr ta-btn-ok\" title=\"Ok\">\n                <i class=\"icon-ok\"></i>\n            </span>\n             <span class=\"ta-btn-wr ta-btn-cancel\" title=\"Cancel\">\n                 <i class=\"icon-cancel-1\"></i>\n             </span>\n        </div>\n    </div>\n    <textarea class=\"text-area-shape-ta\"></textarea>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/graphic/text/textAreaShape/template.hbs
 ** module id = 380
 ** module chunks = 0
 **/